//Componentes generales
import React from "react";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox } from "@fortawesome/free-solid-svg-icons";

const ProductRow = ({ producto }) => {

  const fieldStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "5px",
    padding: "0 44px 0 0",
    whiteSpace: "nowrap",
    fontSize: "1rem",
    fontWeight: "600",
    color: "black",
  };
  const valueStyle = {
    fontWeight: "400",
    color: "rgb(108, 108, 108)",
  };
  const emptyStyle = { ...valueStyle, fontSize: "2.2rem", lineHeight: 1 };

  return (
    <div className="container-p-list-item">
      <div style={{ display: "flex", alignItems: "center", padding: "8px 0" }}>
        <div className='list-item-icon-p'><FontAwesomeIcon icon={faBox} /></div>
        <span style={fieldStyle}>Tipo: <span style={producto.tipPro ? valueStyle : emptyStyle}>{producto.tipPro || "-"}</span></span>
        <span style={fieldStyle}>Código Art.: <span style={producto.artCod ? valueStyle : emptyStyle}>{producto.artCod || "-"}</span></span>
        <span style={fieldStyle}>Cód. Reducido: <span style={producto.codRed ? valueStyle : emptyStyle}>{producto.codRed || "-"}</span></span>
        <span style={fieldStyle}>Descripción: <span style={producto.descrp ? valueStyle : emptyStyle}>{producto.descrp || "-"}</span></span>
        <span style={fieldStyle}>Empresa: <span style={producto.companyName ? valueStyle : emptyStyle}>{producto.companyName || "-"}</span></span>
      </div>
    </div>
  );
};

const RenderRow = ({ index, style, productos = [], filter }) => {
  const lista = filter === ""
    ? productos
    : productos.filter(
        (p) =>
          p.descrp.toLowerCase().includes(filter.toLowerCase()) ||
          p.codRed.toLowerCase().includes(filter.toLowerCase())
      );

  const producto = lista[index];
  if (!producto) return null;

  return (
    <div style={style} className='container-p-list'>
      <li>
        <ProductRow producto={producto} />
      </li>
    </div>
  );
};

export default RenderRow;
